/// <reference path="../../../../../../typings/index.d.ts" />

module Meevo.Plugins.SelfCheckInKiosk {


    class EnhancementsController {
        public static $inject = [
            '$state',
            'meevo.AppSettings',
        ];

        constructor(protected $state: ng.ui.IStateService,
                    protected appSettings: Meevo.Components.Common.IAppSettings) {

        }

        onReady() {
            this.$state.go(`${this.appSettings.ROUTE_NAMES.selfCheckInKiosk}.check-in-success`);
        }
    }


    angular.module('meevo.plugins.selfCheckInKiosk')
        .controller('meevo.plugins.selfCheckInKiosk.EnhancementsController', EnhancementsController);
}
